var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrokenHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 437.775 437.774",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M437.775,150.801c0,110.478-218.893,257.212-218.893,257.212S0,266.569,0,150.801C0,67.584,54.202,29.761,121.041,29.761 c30.946,0,59.093,11.7,80.463,30.818l-55.744,80.925c-1.392,2.021-1.906,4.527-1.421,6.936c0.484,2.403,1.924,4.522,3.992,5.849 l82.958,53.309l-38.178,46.08c-1.921,2.317-2.568,5.433-1.726,8.322l21.359,73.672c1.144,3.955,4.764,6.55,8.709,6.55 c0.703,0,1.425-0.089,2.137-0.255c4.72-1.135,7.705-5.786,6.789-10.551l-12.975-67.033l54.456-54.725 c1.832-1.841,2.784-4.383,2.624-6.966c-0.159-2.598-1.424-4.995-3.476-6.593l-71.732-55.925l77.963-93.629 c1.584-1.906,2.317-4.383,2.033-6.845c-0.142-1.265-0.562-2.471-1.194-3.552c12.129-4.111,25.104-6.387,38.633-6.387 C383.574,29.761,437.775,83.962,437.775,150.801z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenHeart);
export default __webpack_public_path__ + "static/media/broken-heart.6d7c32f2a62033959cd24b73c39914b6.svg";
export { ForwardRef as ReactComponent };